export enum InspectionResultFieldEnum {
  SUPERVISION_TYPE = 'SUPERVISION_TYPE',
  KNO_ORGANIZATION = 'KNO_ORGANIZATION',
  KIND_KNM = 'KIND_KNM',
  PM_TYPE = 'PM_TYPE',
  TYPE = 'TYPE',
  REASON = 'REASON',
  REASON_STATUS = 'REASON_STATUS',
  REASON_DATE_END = 'REASON_DATE_END',
  REASON_CONFORMITY_TYPE = 'REASON_CONFORMITY_TYPE',
  REASON_APPROVAL_PROSECUTOR = 'REASON_APPROVAL_PROSECUTOR',
  REASON_COMPARE_ORGANIZATIONS_IT = 'REASON_COMPARE_ORGANIZATIONS_IT',
  REASON_COMPARE_ORGANIZATIONS_MSP = 'REASON_COMPARE_ORGANIZATIONS_MSP',
  REASON_COMPARE_ORGANIZATIONS_SONKO = 'REASON_COMPARE_ORGANIZATIONS_SONKO',
  POSITION = 'POSITION',
  EVENT = 'EVENT',
  APPROVE_DOC = 'APPROVE_DOC',
  OBJECT_AVAILABLE = 'OBJECT_AVAILABLE',
  OBJECT_NAME = 'OBJECT_NAME',
  OBJECT_ADDRESS = 'OBJECT_ADDRESS',
  OBJECT_TYPE = 'OBJECT_TYPE',
  OBJECT_KIND = 'OBJECT_KIND',
  OBJECT_SUB_KIND = 'OBJECT_SUB_KIND',
  RISK_CATEGORY = 'RISK_CATEGORY',
  DANGER_CLASS = 'DANGER_CLASS',
  FOREIGN_AGENT_NKO_REGISTRY = 'FOREIGN_AGENT_NKO_REGISTRY',
  IT_REGISTRY = 'IT_REGISTRY',
  MSP_REGISTRY = 'MSP_REGISTRY',
  SONKO_NKO_REGISTRY = 'SONKO_NKO_REGISTRY',
  ROT_REGISTRY_REQUIREMENTS_NPA = 'ROT_REGISTRY_REQUIREMENTS_NPA',
  ROT_REGISTRY_STRUCTURAL_UNIT = 'ROT_REGISTRY_STRUCTURAL_UNIT',
  ORGANIZATION_FNS_NAME = 'ORGANIZATION_FNS_NAME',
  ORGANIZATION_FNS_ADDRESS = 'ORGANIZATION_FNS_ADDRESS',
  ORGANIZATION_FNS_FACTUAL_ADDRESS = 'ORGANIZATION_FNS_FACTUAL_ADDRESS',
  ORGANIZATION_FNS_OKVED = 'ORGANIZATION_FNS_OKVED',
  ORGANIZATION_TARGET = 'ORGANIZATION_TARGET',
  RAFP_REGISTRY = 'RAFP_REGISTRY',
  ERVK_ORDER_NUMBER = 'ERVK_ORDER_NUMBER',
  ERVK_ORDER_DATE = 'ERVK_ORDER_DATE',
  ORGANIZATION_ERVK_NAME = 'ORGANIZATION_ERVK_NAME',
  ORGANIZATION_ERVK_ADDRESS = 'ORGANIZATION_ERVK_ADDRESS',
  ORGANIZATION_FNS_NOT_FOUND = 'ORGANIZATION_FNS_NOT_FOUND',
}
